// import { InputField } from "ui-components";
import "./QuestionType.scss";
import { useEffect } from "react";

interface VideoType {
  transcript: string;
  browserSupportsSpeechRecognition: any;
  transcriptEnabled: boolean;
  micImgRef: any;
}
const VideoType: React.FC<VideoType> = ({
  transcript,
  browserSupportsSpeechRecognition,
  // transcriptEnabled,
  micImgRef,
}) => {
  const isFirefox =
    typeof navigator !== "undefined" &&
    navigator.userAgent.toLowerCase().includes("firefox");
  useEffect(() => {}, [transcript]);
  return (
    <>
      {!browserSupportsSpeechRecognition ? (
        !isFirefox && "Browser doesn't support speech recognition"
      ) : (
        <div className="videoType" ref={micImgRef}>
          <img
            width={50}
            height={50}
            src={require("../../../../utils/Images/Microphone.gif")}
            alt="gif"
          />
          {/* <InputField
            additionalProps={{
              as: "textarea",
              rows: 12,
              style: { resize: "none" },
            }}
            value={transcriptEnabled ? transcript : ""}
            onChange={() => {}}
          /> */}
        </div>
      )}
    </>
  );
};

export default VideoType;
